import { useTranslation as useI18nTranslation } from 'react-i18next';

/**
 * Custom hook for translation with simplified API
 * @returns {Object} Translation function and current language
 */
export const useTranslation = () => {
  const { t, i18n } = useI18nTranslation();

  return {
    t,
    language: i18n?.language,
    changeLanguage: (lang) => i18n?.changeLanguage(lang)
  };
};

export default useTranslation;